"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const styles = (0, _makeStyles.default)(theme => ({
  myAccount: {
    "& .mco-user-connection": {
      marginBottom: theme.spacing(4)
    },
    [theme.breakpoints.up("md")]: {
      display: "grid",
      gridTemplateColumns: "300px 1fr"
    }
  }
}));
var _default = exports.default = styles;